import { Component, OnInit, Input } from '@angular/core';
import { AppTitleService } from '../../services/app-title/app-title.service';
import { environment } from '../../../environments/environment';


@Component({
  selector: 'app-title',
  templateUrl: './app-title.component.html',
  styleUrls: ['./app-title.component.css'],
})
export class AppTitleComponent implements OnInit {

  @Input()
  titles: string[];

  constructor(private appTitleService: AppTitleService) { }

  ngOnInit() {
    this.titles = this.appTitleService.titles;
  }

  get isInvisible(): boolean {
    return this.appTitleService.isInvisible;
  }
}
